export default class ScreenNames {
    public static readonly DECONSOLIDATED_LOGIN = 'DeconsolidatedLoginScreen';
    public static readonly USERTYPE_SELECTION = 'UserTypeSelectionScreen';
    public static readonly CSGO_REGION_SELECTION = 'CSGORegionSelectionScreen';
    public static readonly LOGIN_PICKER = 'LoginPickerScreen';
    public static readonly PASSKEY_HELP = 'PasskeyHelpScreen';
}
